import { Link } from "react-router-dom";

const sections = [
  {
    h: "Return Window",
    b: [
      "We accept returns within 15 days of the delivery date for eligible items.",
      "The 15-day period begins on the date your order is delivered.",
    ],
  },
  {
    h: "Eligibility",
    b: [
      "To be eligible for a return, the item must be in its original condition and include all original packaging and accessories.",
      "Certain products may not be eligible for return. If you are unsure, please contact our customer support team before shipping the item back and we will confirm eligibility.",
    ],
  },
  {
    h: "Return Shipping",
    b: [
      "Customers are responsible for return shipping costs.",
      "If the item you received is damaged, defective, or incorrect, Blessings Connection LLC will cover the return shipping cost and provide a prepaid return label.",
    ],
  },
  {
    h: "Refunds",
    b: [
      "Once the returned item has been received and inspected, eligible refunds will be processed to the original payment method used at checkout.",
      "Refund processing times may vary depending on your financial institution. In most cases, refunds appear within 5–10 business days after processing.",
      "Shipping charges paid on the original order are non-refundable, except in cases where the item is damaged, defective, or incorrect.",
    ],
  },
  {
    h: "Damaged, Defective, or Incorrect Items",
    b: [
      "If you receive an item that is damaged, defective, or does not match your order, please contact our customer support team within 7 days of delivery.",
      "Please include your order number and photographs of the item so we can resolve the issue promptly.",
    ],
  },
];

export default function Returns() {
  const updated = "December 2025";
  return (
    <div className="pt-28 md:pt-32 pb-20 bg-[#F9F6F0]" data-testid="returns-page">
      <div className="max-w-[800px] mx-auto px-6">
        <h1
          className="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-3"
          data-testid="returns-title"
        >
          Return &amp; Refund Policy
        </h1>
        <p
          className="text-sm text-slate-500 text-center mb-10"
          data-testid="returns-eyebrow"
        >
          Last Updated: {updated}
        </p>

        <div className="space-y-6 text-base leading-relaxed text-slate-700">
          {sections.map((s, idx) => (
            <section key={s.h} data-testid={`returns-section-${String(idx + 1).padStart(2, "0")}`}>
              <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">{s.h}</h2>
              <div className="space-y-3">
                {s.b.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </section>
          ))}

          <section data-testid="returns-section-support">
            <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">Customer Support</h2>
            <p>If you have any questions about a return or refund, please contact:</p>
            <div className="mt-3">
              <p className="font-medium text-slate-900">Blessings Connection LLC</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:customerservice@blessingsconnection.com"
                  className="text-slate-900 underline hover:text-[#7A2021]"
                  data-testid="returns-contact-email"
                >
                  customerservice@blessingsconnection.com
                </a>
              </p>
              <p className="mt-2">Our customer support team aims to respond within 1–2 business days.</p>
            </div>
            <p className="mt-4 text-sm">
              For shipping and delivery information, please review our{" "}
              <Link to="/shipping" className="text-slate-900 underline hover:text-[#7A2021]">
                Shipping &amp; Cancellations policy
              </Link>.
            </p>
          </section>

          <div className="border-t border-slate-200 pt-6 mt-10">
            <p className="text-sm text-slate-500">
              Blessings Connection LLC · blessingsconnection.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
